import { cn } from '@/utils/cn';

const Text = ({
  as: Component = 'p',
  variant,
  className,
  ...rest
}: TextProps) => {
  return (
    <Component className={cn(variantClasses[variant], className)} {...rest} />
  );
};

export default Text;

type TextVariant =
  | 'navItem'
  | 'heroTitle'
  | 'heroSubtitle'
  | 'ctaButton'
  | 'cardLink'
  | 'lSButton'
  | 'paragraph'
  | 'sectionTitle'
  | 'sectionEyebrow'
  | 'cardTitle'
  | 'cardEyebrow'
  | 'formLabel'
  | 'formInput'
  | 'formConsent'
  | 'formError'
  | 'submitButton'
  | 'footerLink'
  | 'footerTitle'
  | 'copyright';

type TextProps = React.HTMLAttributes<HTMLElement> & {
  as?: React.ElementType;
  variant: TextVariant;
};

const variantClasses: Record<TextVariant, string> = {
  navItem:
    'text-nav-item font-medium leading-tight tracking-wide capitalize text-text-secondary hover:text-secondary',

  heroTitle: 'text-hero-title font-bold leading-tight tracking-none mb-2.5',

  heroSubtitle: 'text-hero-subtitle font-normal leading-tight mb-2.5',

  ctaButton:
    'text-cta-button font-semibold leading-tight tracking-wide uppercase',

  cardLink: 'text-cta-button font-semibold leading-tight tracking-wide',

  lSButton:
    'text-ls-button font-semibold leading-tight tracking-wide uppercase',

  paragraph:
    'text-paragraph font-normal leading-relaxed text-text-secondary mb-4',

  sectionTitle: 'text-section-title font-semibold leading-tight text-text',

  sectionEyebrow:
    'text-section-subtitle font-semibold leading-tight tracking-wide uppercase text-secondary mb-2.5',

  cardTitle: 'text-card-title font-semibold leading-tight text-text',

  cardEyebrow:
    'text-card-eyebrow font-semibold leading-tight tracking-wide uppercase text-secondary',

  formLabel: 'text-form-label font-semibold leading-tight text-text',

  formInput:
    'text-form-input font-semibold desktop:font-normal leading-relaxed text-text',

  formError:
    'text-form-error min-h-[1rem] mt-1 text-secondary transition-opacity duration-200',

  formConsent: 'text-form-consent',

  submitButton:
    'text-submit-button font-semibold leading-tight uppercase text-white',

  footerTitle:
    'text-footer-title font-bold leading-tight tracking-none mb-2.5 text-white',

  footerLink: 'text-footer-link font-medium leading-tight text-white',

  copyright: 'text-copyright leading-tight text-white',
};
